export default [
    {
        currencyName: 'GBP',
        currencySymbol: '£',
    },
    {
        currencyName: 'USD',
        currencySymbol: '$',
    },
    {
        currencyName: 'EUR',
        currencySymbol: '€',
    },
];